import TableController from './TableController';

export default TableController;
